<aaa-file-manager-list *ngIf="jwtAuthService.tokenVerified" [directory]="directory"></aaa-file-manager-list>
